<script lang="ts" setup>
const videos: { [key: string]: string } = {
  nl: 'https://www.youtube-nocookie.com/embed/Wkz-xPEdUHM?si=NXMnyH2v7MqiYQQJ',
  de: 'https://www.youtube-nocookie.com/embed/8mi-unZxeKA?si=p4uAPuR05_lcU9B6',
  en: 'https://www.youtube-nocookie.com/embed/gMWngCSc-KA?si=NTXDSSFfyqeimSmG',
  fr: 'https://www.youtube-nocookie.com/embed/ICCy88gyY14?si=CERzJ4Ibn6Mj21NE',
}

const { locale } = useI18n()
</script>

<template>
  <div class="overflow-hidden rounded-lg shadow-xl">
    <iframe class="h-full w-full aspect-video" :src="videos[locale]" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen />
  </div>
</template>
